function cipher(input, decode) {
    function isJSON(str) {
       try {
          return (JSON.parse(str) && !!str);
       } catch (e) {
          return false;
       }
    }
    function replace(text, map) {
       return text.split('').map(function(v) {
          if (typeof map[v.toLowerCase()] === 'undefined')
             return v;
          if (v.toLowerCase() != v) {
             return map[v.toLowerCase()].toUpperCase();
          }else{
             return map[v];
          }
       }).join('');
    }
    // ABCDEF to QWERTY map
    // var map = {
    //    a: 'q', b: 'w', c: 'e',
    //    d: 'r', e: 't', f: 'y',
    //    g: 'u', h: 'i', i: 'o',
    //    j: 'p', k: 'a', l: 's',
    //    m: 'd', n: 'f', o: 'g',
    //    p: 'h', q: 'j', r: 'k',
    //    s: 'l', t: 'z', u: 'x',
    //    v: 'c', w: 'v', x: 'b',
    //    y: 'n', z: 'm'
    // };
    var encodeMap = JSON.parse(atob('eyJhIjoicSIsImIiOiJ3IiwiYyI6ImUiLCJkIjoiciIsImUiOiJ0IiwiZiI6InkiLCJnIjoidSIsImgiOiJpIiwiaSI6Im8iLCJqIjoicCIsImsiOiJhIiwibCI6InMiLCJtIjoiZCIsIm4iOiJmIiwibyI6ImciLCJwIjoiaCIsInEiOiJqIiwiciI6ImsiLCJzIjoibCIsInQiOiJ6IiwidSI6IngiLCJ2IjoiYyIsInciOiJ2IiwieCI6ImIiLCJ5IjoibiIsInoiOiJtIn0='));
    // Flip the map
    var decodeMap = (function() {
       var tmp = {};
       var k;
 
       // Populate the tmp variable
       for (k in encodeMap) {
          if (!encodeMap.hasOwnProperty(k)) continue;
          tmp[encodeMap[k]] = k;
       }
 
       return tmp;
    })();
 
    if (!decode) {
       var rawString = (typeof input === 'object') ? JSON.stringify(input) : input;
       var b64 = window.btoa(unescape(encodeURIComponent(rawString)));
 
       return replace(b64, encodeMap);
    }else{
       var b64 = input;
 
       var result = decodeURIComponent(escape(window.atob(replace(b64, decodeMap))));
 
       if (isJSON(result)) {
          return JSON.parse(result);
       }
 
       return result;
    }
 };
 

 export default {
     encode: input => cipher(input, false),
     decode: input => cipher(input, true)
 };